import FieldStrategy from '../FieldStrategy';
import { checkboxFilterNone, transformSelectedTimeToTimeSeries } from '@/tools/form';
import { generateDynamicFormModel } from '@/views/fusion/investment/intelligence-create/tools/form';
import { clone, deepMerge } from '@/utils';
import {
  CAMPAIGN_MODULE_KEY,
  CREATIVE_MODULE_KEY,
  TARGETING_MODULE_KEY,
} from '@/views/fusion/investment/intelligence-create/strategy/constants';
import { OPTIONS_TYPE, CHANNEL_INTERFACE_TYPE, TIME_PERIOD_LENGTH } from '@/enums';
import calculator from '@/utils/calculator';

const creative_ad_desc = {
  label: '创意文案',
  type: 'input',
  props: {
    placeholder: '请输入创意文案',
    maxlength: 15,
    showWordLimit: true,
  },
  value: '',
  rules: [],
};

// 【创意组件】表单配置
const creative_components_config = {
  creative_ad_desc,
};

/**
 * VIVO策略类
 */
export default class VivoFieldStrategy extends FieldStrategy {
  /**
   * 获取差异化模块字段
   * @returns {Object}
   */
  getDifferentiatedFields() {
    return {
      campaign_config: {
        config: {
          delivery_form: {
            config: {
              delivery_platform_type: {
                value: '2',
              },
              delivery_content_id: {
                type: '',
                is_single_advertiser_assign: true,
                is_open: false,
                value: {
                  type_selection: [
                    { label: 'Android应用', value: '2' },
                  ],
                  result_map: {},
                },
                backup_value: {
                  type_selection: [
                    { label: 'Android应用', value: '2' },
                  ],
                  result_map: {},
                },
                isPreview: false,
                rules: {
                  required: true,
                  trigger: ['change'],
                  validator: (_, value, callback) => {
                    if (Object.keys(value.result_map).length) {
                      callback();
                    } else {
                      callback(new Error('请选择投放内容'));
                    }
                  },
                },
              },
              media_type: {
                label: '计划类型',
                type: 'radio-group',
                isButton: true,
                options: [
                  { label: '商店', value: '0' },
                  { label: '非商店', value: '1' },
                ],
                value: '1',
                backup_value: '1',
              },
            },
          },
          site_form: {
            config: {
              site_set_type: {
                props: {
                  disabled: true,
                },
                value: 2,
              },
              site_sets: {
                hidden: false,
                props: {
                  max: 1,
                },
                value: ['1'],
                rules: { required: true, message: '请选择广告版位', trigger: ['change'] },
              },
            },
          },
          budget_and_bid_form: {
            config: {
              price_type: {
                options_map: {
                  '0': [
                    { label: 'CPD', value: '4' },
                    { label: 'oCPD', value: '5' },
                  ],
                  '1': [
                    { label: 'CPC', value: '2' },
                    { label: 'oCPC', value: '3' },
                    { label: 'CPM', value: '1' },
                  ],
                },
                value: '3',
              },
              price: {
                hidden: true,
              },
              price_strategy: {
                hidden: false,
                value: '0',
              },
              convert_id: {
                hidden: true,
              },
              fusion__optimize_goal: {
                label: '优化目标',
                type: 'select',
                hidden: false,
                props: {
                  clearable: false,
                },
                options: [],
                value: '',
                backup_value: '',
                rules: { required: true, message: '请选择优化目标', trigger: ['change'] },
              },
              deep_convert_type: {
                hidden: true,
              },
              deep_convert_price: {
                hidden: true,
              },
              spent_type: {
                label: '投放类型',
                type: 'radio-group',
                isButton: true,
                props: {
                  disabled: true,
                },
                options: [
                  { label: '加速投放', value: '1' },
                  { label: '匀速投放', value: '2' },
                ],
                value: '1',
              },
              converted_user_filter_days_selection: {
                label: '过滤已转化用户',
                type: 'radio-group',
                hidden: true,
                isButton: true,
                options: [
                  { label: '开启', value: OPTIONS_TYPE.CUSTOM },
                  { label: '关闭', value: OPTIONS_TYPE.UNLIMITED },
                ],
                value: OPTIONS_TYPE.CUSTOM,
              },
              converted_user_filter_days: {
                label: ' ',
                type: 'select',
                hidden: true,
                options: [],
                value: '7',
                rules: { required: true, message: '请选择过滤已转化用户', trigger: ['change'] },
              },
              convert_goal_price: {
                label: '优化目标出价',
                type: 'input-number',
                hidden: true,
                props: {
                  step: 1,
                  precision: 2,
                  min: 0.01,
                  max: 999999999.00,
                },
                formItemTips: {
                  props: {
                    class: 'inline-block',
                    style: {
                      marginLeft: '10px',
                    },
                  },
                  content: '元',
                },
                value: undefined,
                rules: { required: true, message: '请输入优化目标出价', trigger: ['change'] },
              },
              convert_goal_roi: {
                label: '优化ROI系数出价',
                type: 'input-number',
                hidden: true,
                props: {
                  step: 1,
                  precision: 3,
                  min: 0.001,
                  max: 1000,
                },
                value: undefined,
                rules: { required: true, message: '请输入优化ROI系数出价', trigger: ['change'] },
              },
              deep_convert_goal_price: {
                label: '深度优化出价',
                type: 'input-number',
                hidden: true,
                props: {
                  step: 1,
                  precision: 2,
                  min: 0.01,
                  max: 999999999.00,
                },
                formItemTips: {
                  props: {
                    class: 'inline-block',
                    style: {
                      marginLeft: '10px',
                    },
                  },
                  content: '元',
                },
                value: undefined,
                rules: { required: true, message: '请输入优化目标出价', trigger: ['change'] },
              },
              deep_convert_goal_roi: {
                label: '深度ROI系数出价',
                type: 'input-number',
                hidden: true,
                props: {
                  step: 1,
                  precision: 3,
                  min: 0.001,
                  max: 1000,
                },
                value: undefined,
                rules: { required: true, message: '请输入优化ROI系数出价', trigger: ['change'] },
              },
            },
          },
        },
      },
      creative_config: {
        config: {
          content_form: {
            config: {
              delivery_mode: {
                label: '投放模式',
                type: 'radio-group',
                isButton: true,
                props: {
                  disabled: true,
                },
                options: [
                  { label: '组件化创意', value: '1' },
                  { label: '自定义创意', value: '2' },
                ],
                value: '2',
              },
              creative_template_id: {
                label: '创意形式',
                type: 'radio-group',
                isBox: true,
                hidden: false,
                options: [],
                value: null,
                backup_value: null,
              },
              delivery_position_list: {
                label: '投放位置',
                type: 'checkbox-group',
                hidden: false,
                props: {
                  min: 1,
                },
                options: [],
                isBox: true,
                value: [],
              },
            },
          },
        },
      },
      targeting_config: {
        config: {
          targeting_form: {
            config: {
              // 年龄
              ages: {
                value: {},
                children: {
                  ages_selection: {
                    label: '年龄',
                    type: 'radio-group',
                    isButton: true,
                    options: [
                      { label: '不限', value: OPTIONS_TYPE.UNLIMITED },
                      { label: '指定年龄段', value: OPTIONS_TYPE.CUSTOM },
                    ],
                    value: OPTIONS_TYPE.UNLIMITED,
                  },
                  ages: {
                    label: ' ',
                    type: 'checkbox-group',
                    hidden: true,
                    isBox: true,
                    options: [],
                    value: [],
                    rules: { required: true, message: '请选择年龄段', trigger: ['change'] },
                  },
                },
              },
              // APP安装
              app_install_status: {
                label: 'APP安装',
                type: 'radio-group',
                isButton: true,
                options: [],
                value: '1',
              },
              // 安装行为
              install_behavior: {
                value: {},
                children: {
                  install_behavior_selection: {
                    label: '安装行为',
                    type: 'checkbox-group',
                    isButton: true,
                    options: [
                      { label: '不限', value: OPTIONS_TYPE.UNLIMITED },
                      { label: '按应用分类', value: 'app_category' },
                      { label: '按游戏分类', value: 'game_category' },
                    ],
                    value: [OPTIONS_TYPE.UNLIMITED],
                  },
                  app_category: {
                    label: ' ',
                    type: 'tree-shuttle',
                    name: '按应用分类',
                    props: {
                      nodeKey: 'value',
                    },
                    hidden: true,
                    options: [],
                    value: [],
                    rules: {
                      required: true,
                      trigger: ['blur'],
                      validator: (_, value, callback) => {
                        if (value.length) {
                          callback();
                        } else {
                          callback(new Error('请选择应用分类'));
                        }
                      },
                    },
                  },
                  game_category: {
                    label: ' ',
                    type: 'tree-shuttle',
                    name: '按游戏分类',
                    props: {
                      nodeKey: 'value',
                      checkStrictly: false, // 不可选一级分类，所以变更为固定选中子级
                    },
                    hidden: true,
                    options: [],
                    value: [],
                    rules: {
                      required: true,
                      trigger: ['blur'],
                      validator: (_, value, callback) => {
                        if (value.length) {
                          callback();
                        } else {
                          callback(new Error('请选择游戏分类'));
                        }
                      },
                    },
                  },
                  install_behavior_days: {
                    label: '安装行为天数',
                    type: 'radio-group',
                    hidden: true,
                    isButton: true,
                    options: [],
                    value: '365',
                  },
                },
              },
              // 启动行为
              start_behavior: {
                value: {},
                children: {
                  start_behavior_selection: {
                    label: '启动行为',
                    type: 'checkbox-group',
                    isButton: true,
                    options: [
                      { label: '不限', value: OPTIONS_TYPE.UNLIMITED },
                      { label: '按应用分类', value: 'app_category' },
                      { label: '按游戏分类', value: 'game_category' },
                    ],
                    value: [OPTIONS_TYPE.UNLIMITED],
                  },
                  app_category: {
                    label: ' ',
                    type: 'tree-shuttle',
                    name: '按应用分类',
                    props: {
                      nodeKey: 'value',
                    },
                    hidden: true,
                    options: [],
                    value: [],
                    rules: {
                      required: true,
                      trigger: ['blur'],
                      validator: (_, value, callback) => {
                        if (value.length) {
                          callback();
                        } else {
                          callback(new Error('请选择应用分类'));
                        }
                      },
                    },
                  },
                  game_category: {
                    label: ' ',
                    type: 'tree-shuttle',
                    name: '按游戏分类',
                    props: {
                      nodeKey: 'value',
                      checkStrictly: false, // 不可选一级分类，所以变更为固定选中子级
                    },
                    hidden: true,
                    options: [],
                    value: [],
                    rules: {
                      required: true,
                      trigger: ['blur'],
                      validator: (_, value, callback) => {
                        if (value.length) {
                          callback();
                        } else {
                          callback(new Error('请选择游戏分类'));
                        }
                      },
                    },
                  },
                  start_behavior_type: {
                    label: '启动行为类型',
                    type: 'radio-group',
                    hidden: true,
                    isButton: true,
                    options: [],
                    value: '1',
                  },
                  start_behavior_days: {
                    label: '启动行为天数',
                    type: 'radio-group',
                    hidden: true,
                    isButton: true,
                    options: [],
                    value: '-1',
                  },
                },
              },
              // 兴趣行为
              business_interest_list: {
                value: {},
                children: {
                  business_interest_list_selection: {
                    label: '兴趣行为',
                    type: 'radio-group',
                    isButton: true,
                    options: [
                      { label: '不限', value: OPTIONS_TYPE.UNLIMITED },
                      { label: '自定义', value: OPTIONS_TYPE.CUSTOM },
                    ],
                    value: OPTIONS_TYPE.UNLIMITED,
                  },
                  business_interest_list: {
                    label: ' ',
                    type: 'tree-shuttle',
                    name: '兴趣行为',
                    props: {
                      nodeKey: 'value',
                      maxCount: 200,
                    },
                    hidden: true,
                    options: [],
                    value: [],
                    rules: {
                      required: true,
                      trigger: ['blur'],
                      validator: (_, value, callback) => {
                        if (value.length) {
                          callback();
                        } else {
                          callback(new Error('请选择兴趣行为'));
                        }
                      },
                    },
                  },
                },
              },
              // 网络环境
              network_type: {
                label: '网络环境',
                type: 'radio-group',
                isButton: true,
                options: [],
                value: '1',
              },
              // 安卓版本
              android_version_list: {
                value: {},
                children: {
                  android_version_list_selection: {
                    label: '安卓版本',
                    type: 'radio-group',
                    isButton: true,
                    options: [
                      { label: '不限', value: OPTIONS_TYPE.UNLIMITED },
                      { label: '自定义', value: OPTIONS_TYPE.CUSTOM },
                    ],
                    value: OPTIONS_TYPE.UNLIMITED,
                  },
                  android_version_list: {
                    label: ' ',
                    type: 'checkbox-group',
                    hidden: true,
                    isBox: true,
                    options: [],
                    value: [],
                    rules: { required: true, message: '请选择安卓版本', trigger: ['change'] },
                  },
                },
              },
              // 购机价格
              device_price_list: {
                value: {},
                children: {
                  device_price_list_selection: {
                    label: '购机价格',
                    type: 'radio-group',
                    isButton: true,
                    options: [
                      { label: '不限', value: OPTIONS_TYPE.UNLIMITED },
                      { label: '自定义', value: OPTIONS_TYPE.CUSTOM },
                    ],
                    value: OPTIONS_TYPE.UNLIMITED,
                  },
                  device_price_list: {
                    label: ' ',
                    type: 'checkbox-group',
                    hidden: true,
                    isBox: true,
                    options: [],
                    value: [],
                    rules: { required: true, message: '请选择购机价格', trigger: ['change'] },
                  },
                },
              },
              // 手机系列
              phone_series_list: {
                value: {},
                children: {
                  phone_series_list_selection: {
                    label: '手机系列',
                    type: 'radio-group',
                    isButton: true,
                    options: [
                      { label: '不限', value: OPTIONS_TYPE.UNLIMITED },
                      { label: '自定义', value: OPTIONS_TYPE.CUSTOM },
                    ],
                    value: OPTIONS_TYPE.UNLIMITED,
                  },
                  phone_series_list: {
                    label: ' ',
                    type: 'checkbox-group',
                    hidden: true,
                    isBox: true,
                    options: [],
                    value: [],
                    rules: { required: true, message: '请选择手机系列', trigger: ['change'] },
                  },
                },
              },
              // 运营商
              network_operator_list: {
                label: '运营商',
                type: 'checkbox-group',
                isButton: true,
                options: [],
                value: [OPTIONS_TYPE.UNLIMITED],
              },
            },
          },
        },
      },
      material_config: {
        config: {
          material_form: {
            config: {
              material: {
                props: {
                  type: 'image',
                  tempMaterial: null,
                },
                materialRestriction: [],
                material_type: null,
              },
            },
          },
        },
      },
    };
  }

  /**
   * 添加事件
   * @param {Object} config 模块配置
   * @param {Object} controller 控制器
   */
  addEvent(config, controller) {
    this.config = config;
    super.addEvent(config);
    const {
      campaign_config: {
        config: {
          delivery_form,
          site_form,
          budget_and_bid_form,
        },
      },
    } = config;

    const { delivery_platform_type, delivery_content_id, media_type } = delivery_form.config;
    const { site_sets } = site_form.config;
    const {
      daily_budget_type,
      daily_budget,
      price_type,
      price,
      price_strategy,
      fusion__optimize_goal,
      deep_convert_type,
      spent_type,
      converted_user_filter_days_selection,
      converted_user_filter_days,
      convert_goal_price,
      convert_goal_roi,
      deep_convert_goal_price,
      deep_convert_goal_roi,
    } = budget_and_bid_form.config;

    // 投放平台
    delivery_platform_type.on = {
      change: () => {},
    };

    // 投放内容
    delivery_content_id.on = {
      change: async() => {
        const first_package_name = Object.entries(delivery_content_id.value.result_map)?.[0]?.[1]?.value?.split?.('#')?.[1];
        const is_change = JSON.stringify(delivery_content_id.value) !== JSON.stringify(delivery_content_id.backup_value);
        if (is_change && first_package_name) {
          delivery_content_id.backup_value = JSON.parse(JSON.stringify(delivery_content_id.value));

          // 获取优化目标
          fusion__optimize_goal.options = await controller.getConvertGoalList({
            vivo_params: {
              filtering: {
                delivery_platform_type: delivery_platform_type.value,
                media_type: media_type.value,
                package_name: first_package_name,
              },
            },
          });
          const is_match_optimize_goal = fusion__optimize_goal.options.some(({ value }) => fusion__optimize_goal.value === value);
          if (!is_match_optimize_goal) {
            fusion__optimize_goal.value = '';
            fusion__optimize_goal.backup_value = '';
            deep_convert_type.value = '';
            deep_convert_type.options = [];
          }

          // 获取深度优化目标
          if (fusion__optimize_goal.value) {
            deep_convert_type.options = await controller.getDeepConvertGoalList({
              vivo_params: {
                filtering: {
                  delivery_platform_type: delivery_platform_type.value,
                  media_type: media_type.value,
                  package_name: first_package_name,
                  convert_goal: fusion__optimize_goal.value,
                },
              },
            });
            const is_match_deep_convert_type = deep_convert_type.options.some(({ value }) => deep_convert_type.value === value);
            !is_match_deep_convert_type && (deep_convert_type.value = deep_convert_type.options.length ? deep_convert_type.options[0].value : '');
          }
        }
        price_type.on.change();
      },
    };

    // 计划类型
    media_type.on = {
      change: async() => {
        const first_package_name = Object.entries(delivery_content_id.value.result_map)?.[0]?.[1]?.value?.split?.('#')?.[1];
        if (media_type.value !== media_type.backup_value) {
          media_type.backup_value = media_type.value;

          // 获取版位
          site_sets.options = await controller.getSiteSet({
            vivo_params: {
              filtering: {
                media_type: media_type.value,
              },
            },
          });
          const is_match_site_sets = !site_sets.value.length ? false : site_sets.options.some(({ value }) => site_sets.value[0] === value);
          !is_match_site_sets && (site_sets.value = [site_sets.options[0].value]);

          if (first_package_name) {
            // 获取优化目标
            fusion__optimize_goal.options = await controller.getConvertGoalList({
              vivo_params: {
                filtering: {
                  delivery_platform_type: delivery_platform_type.value,
                  media_type: media_type.value,
                  package_name: first_package_name,
                },
              },
            });
            const is_match_optimize_goal = fusion__optimize_goal.options.some(({ value }) => fusion__optimize_goal.value === value);
            if (!is_match_optimize_goal) {
              fusion__optimize_goal.value = '';
              fusion__optimize_goal.backup_value = '';
              deep_convert_type.value = '';
              deep_convert_type.options = [];
            }

            // 获取深度优化目标
            if (fusion__optimize_goal.value) {
              deep_convert_type.options = await controller.getDeepConvertGoalList({
                vivo_params: {
                  filtering: {
                    delivery_platform_type: delivery_platform_type.value,
                    media_type: media_type.value,
                    package_name: first_package_name,
                    convert_goal: fusion__optimize_goal.value,
                  },
                },
              });
              const is_match_deep_convert_type = deep_convert_type.options.some(({ value }) => deep_convert_type.value === value);
              !is_match_deep_convert_type && (deep_convert_type.value = deep_convert_type.options.length ? deep_convert_type.options[0].value : '');
            }
          }
        }

        daily_budget_type.on.change();

        // 获取出价方式
        price_type.options = price_type.options_map[media_type.value];
        const is_match = price_type.options.some(({ value }) => price_type.value === value);
        !is_match && (price_type.value = price_type.options[0].value);
        price_type.on.change();
      },
    };

    // 日预算类型
    daily_budget_type.on = {
      change() {
        const is_day = daily_budget_type.value === 'BUDGET_MODE_DAY';
        const is_shop = media_type.value === '0';
        daily_budget.hidden = !is_day;

        // 非商店且指定日预算时，才允许选择匀速投放
        const is_only_speed = !is_shop && is_day;
        spent_type.props.disabled = !is_only_speed;
        !is_only_speed && (spent_type.value = '1');
      },
    };

    // 出价方式
    price_type.on = {
      change: () => {
        const is_ocpx = ['3', '5'].includes(price_type.value);
        price.hidden = is_ocpx;
        price_strategy.hidden = !is_ocpx;
        fusion__optimize_goal.hidden = !is_ocpx;
        fusion__optimize_goal.on.change();
      },
    };

    // 优化目标
    fusion__optimize_goal.on = {
      change: async() => {
        const first_package_name = Object.entries(delivery_content_id.value.result_map)?.[0]?.[1]?.value?.split?.('#')?.[1];
        const is_has_optimize_goal = !!fusion__optimize_goal.value;
        const is_ocpx = ['3', '5'].includes(price_type.value);
        const is_roi = fusion__optimize_goal.options.some(({ value, is_roi }) => fusion__optimize_goal.value === value && is_roi);

        convert_goal_price.hidden = !(is_ocpx && is_has_optimize_goal && !is_roi);
        convert_goal_roi.hidden = !(is_ocpx && is_has_optimize_goal && is_roi);

        // 优化目标为自定义激活、自定义注册和自定义付费时显示
        converted_user_filter_days_selection.hidden = !(is_ocpx && ['5', '6', '12'].includes(fusion__optimize_goal.value));
        converted_user_filter_days_selection.on.change();

        const is_change = fusion__optimize_goal.value !== fusion__optimize_goal.backup_value;
        if (is_change && first_package_name) {
          fusion__optimize_goal.backup_value = fusion__optimize_goal.value;
          // 获取深度优化目标
          deep_convert_type.options = await controller.getDeepConvertGoalList({
            vivo_params: {
              filtering: {
                delivery_platform_type: delivery_platform_type.value,
                media_type: media_type.value,
                package_name: first_package_name,
                convert_goal: fusion__optimize_goal.value,
              },
            },
          });
          const is_match_deep_convert_type = deep_convert_type.options.some(({ value }) => deep_convert_type.value === value);
          !is_match_deep_convert_type && (deep_convert_type.value = deep_convert_type.options.length ? deep_convert_type.options[0].value : '');
        }

        deep_convert_type.hidden = !(is_ocpx && is_has_optimize_goal && deep_convert_type.options.length);
        deep_convert_type.on.change();
      },
    };

    // 深度优化目标
    deep_convert_type.on = {
      change: async() => {
        const is_has_deep_convert_type = !!deep_convert_type.value && !deep_convert_type.hidden;
        const is_ocpx = ['3', '5'].includes(price_type.value);
        const is_roi = deep_convert_type.options.some(({ value, is_roi }) => deep_convert_type.value === value && is_roi);
        deep_convert_goal_price.hidden = !(is_ocpx && is_has_deep_convert_type && !is_roi);
        deep_convert_goal_roi.hidden = !(is_ocpx && is_has_deep_convert_type && is_roi);
      },
    };

    // 过滤已转化用户
    converted_user_filter_days_selection.on = {
      change: () => {
        const is_custom = converted_user_filter_days_selection.value === OPTIONS_TYPE.CUSTOM;
        const is_ocpx = ['3', '5'].includes(price_type.value);
        converted_user_filter_days.hidden = !(is_ocpx && is_custom && ['5', '6', '12'].includes(fusion__optimize_goal.value));
      },
    };

    const {
      creative_config: {
        config: {
          content_form,
        },
      },
    } = config;
    const { creative_template_id } = content_form.config;

    // 创意形式
    creative_template_id.on = {
      change: async() => {
        // 获取创意动态组件
        if (creative_template_id.value !== creative_template_id.backup_value) {
          creative_template_id.backup_value = creative_template_id.value;
          const {
            campaign_config: {
              config: {
                site_form: {
                  config: {
                    site_sets,
                  },
                },
              },
            },
          } = config;

          const params = {
            filtering: {
              site_sets: site_sets.value,
            },
            vivo_params: {
              filtering: {
                creative_template_id: creative_template_id.value,
              },
            },
          };

          this.renderDynamicComponent({ config, params, controller });
        }
      },
    };

    const {
      targeting_config: {
        config: {
          targeting_form,
        },
      },
    } = config;
    const {
      ages: {
        children: {
          ages_selection,
          ages,
        },
      },
      install_behavior: {
        children: {
          install_behavior_selection,
          app_category,
          game_category,
          install_behavior_days,
        },
      },
      start_behavior: {
        children: {
          start_behavior_selection,
          app_category: start_behavior_app_category,
          game_category: start_behavior_game_category,
          start_behavior_type,
          start_behavior_days,
        },
      },
      business_interest_list: {
        children: {
          business_interest_list_selection,
          business_interest_list,
        },
      },
      android_version_list: {
        children: {
          android_version_list_selection,
          android_version_list,
        },
      },
      device_price_list: {
        children: {
          device_price_list_selection,
          device_price_list,
        },
      },
      phone_series_list: {
        children: {
          phone_series_list_selection,
          phone_series_list,
        },
      },
      network_operator_list,
    } = targeting_form.config;

    // 年龄
    ages_selection.on = {
      change: () => {
        const is_custom = ages_selection.value === OPTIONS_TYPE.CUSTOM;
        ages.hidden = !is_custom;
      },
    };

    // 安装行为
    install_behavior_selection.on = {
      change: () => {
        install_behavior_selection.value = checkboxFilterNone(install_behavior_selection.value, OPTIONS_TYPE.UNLIMITED);
        const is_app = install_behavior_selection.value.includes('app_category');
        const is_game = install_behavior_selection.value.includes('game_category');
        app_category.hidden = !is_app;
        game_category.hidden = !is_game;
        install_behavior_days.hidden = !(is_app || is_game);
      },
    };

    // 启动行为
    start_behavior_selection.on = {
      change: () => {
        start_behavior_selection.value = checkboxFilterNone(start_behavior_selection.value, OPTIONS_TYPE.UNLIMITED);
        const is_app = start_behavior_selection.value.includes('app_category');
        const is_game = start_behavior_selection.value.includes('game_category');
        start_behavior_app_category.hidden = !is_app;
        start_behavior_game_category.hidden = !is_game;
        start_behavior_type.hidden = !(is_app || is_game);
        start_behavior_type.on.change();
      },
    };

    // 启动行为类型
    start_behavior_type.on = {
      change: () => {
        const is_open = start_behavior_type.value === '1';
        const is_app = start_behavior_selection.value.includes('app_category');
        const is_game = start_behavior_selection.value.includes('game_category');
        start_behavior_days.hidden = !((is_app || is_game) && is_open);
      },
    };

    // 兴趣行为
    business_interest_list_selection.on = {
      change: () => {
        const is_custom = business_interest_list_selection.value === OPTIONS_TYPE.CUSTOM;
        business_interest_list.hidden = !is_custom;
      },
    };

    // 安卓版本
    android_version_list_selection.on = {
      change: () => {
        const is_custom = android_version_list_selection.value === OPTIONS_TYPE.CUSTOM;
        android_version_list.hidden = !is_custom;
      },
    };

    // 购机价格
    device_price_list_selection.on = {
      change: () => {
        const is_custom = device_price_list_selection.value === OPTIONS_TYPE.CUSTOM;
        device_price_list.hidden = !is_custom;
      },
    };

    // 手机系列
    phone_series_list_selection.on = {
      change: () => {
        const is_custom = phone_series_list_selection.value === OPTIONS_TYPE.CUSTOM;
        phone_series_list.hidden = !is_custom;
      },
    };

    // 运营商
    network_operator_list.on = {
      change: () => {
        network_operator_list.value = checkboxFilterNone(network_operator_list.value, OPTIONS_TYPE.UNLIMITED);
      },
    };
  }

  /**
   * 获取覆盖字符对象
   * @returns {Object}
   */
  getDifferentiatedOverrides() {
    return {};
  }

  /**
   * 设置配置模块的数据源
   * @param {Object} config 模块表单配置
   * @param {Object} controller 控制器
   */
  async setFieldDataSources(config, controller) {
    try {
      await super.setFieldDataSources(config, controller);
      const {
        campaign_config: {
          config: {
            budget_and_bid_form,
          },
        },
      } = config;
      const { price_type, converted_user_filter_days } = budget_and_bid_form.config;
      price_type.options = price_type.options_map['1'];
      const promises_map = [
        // 过滤已转化用户
        [
          () => controller.getConvertedUserFilterDaysList(),
          (res) => {
            converted_user_filter_days.options = res;
          },
        ],
      ];
      const values = await Promise.all(promises_map.map(([promise]) => promise()));
      promises_map.forEach(([_, handler], index) => handler(values[index]));
    } catch (error) {
      console.error(error);
      throw new Error('VivoFieldStrategy: setFieldDataSources fail');
    }
  }

  /**
   * 设置定向模块的数据源
   * @param {Object} config 模块表单配置
   * @param {Object} controller 控制器
   * @param {Object} form_fields 源数据表单配置
   */
  async setTargetingDataSources(config, controller, form_fields) {
    await super.setTargetingDataSources(config, controller, form_fields);
    const {
      ages: {
        children: {
          ages,
        },
      },
      app_install_status,
      install_behavior: {
        children: {
          app_category,
          game_category,
          install_behavior_days,
        },
      },
      start_behavior: {
        children: {
          app_category: start_behavior_app_category,
          game_category: start_behavior_game_category,
          start_behavior_type,
          start_behavior_days,
        },
      },
      business_interest_list: {
        children: {
          business_interest_list,
        },
      },
      network_type,
      android_version_list: {
        children: {
          android_version_list,
        },
      },
      device_price_list: {
        children: {
          device_price_list,
        },
      },
      phone_series_list: {
        children: {
          phone_series_list,
        },
      },
      network_operator_list,
    } = config.targeting_config.config.targeting_form.config;

    // 定向字典
    const targeting_dictionary = await controller.getTargetingDictionary(['age', 'app_install_status', 'install_behavior_days', 'start_behavior_days', 'start_behavior_type', 'app_category', 'game_category', 'business_interest', 'network_type', 'android_version', 'device_price', 'phone_series', 'network_operator']);
    const unlimited_selection = { label: '不限', value: OPTIONS_TYPE.UNLIMITED };

    // 年龄
    ages.options = targeting_dictionary?.age || [];
    // APP安装
    app_install_status.options = targeting_dictionary?.app_install_status || [];
    // 安装行为
    app_category.options = targeting_dictionary?.app_category || [];
    game_category.options = targeting_dictionary?.game_category || [];
    install_behavior_days.options = targeting_dictionary?.install_behavior_days || [];
    // 启动行为
    start_behavior_app_category.options = targeting_dictionary?.app_category || [];
    start_behavior_game_category.options = targeting_dictionary?.game_category || [];
    start_behavior_type.options = targeting_dictionary?.start_behavior_type || [];
    start_behavior_days.options = targeting_dictionary?.start_behavior_days || [];
    // 兴趣行为
    business_interest_list.options = targeting_dictionary?.business_interest || [];
    // 网络环境
    network_type.options = targeting_dictionary?.network_type || [];
    // 安卓版本
    android_version_list.options = targeting_dictionary?.android_version || [];
    // 购机价格
    device_price_list.options = targeting_dictionary?.device_price || [];
    // 手机系列
    phone_series_list.options = targeting_dictionary?.phone_series || [];
    // 运营商
    network_operator_list.options = [unlimited_selection, ...(targeting_dictionary?.network_operator || [])];
  }

  /**
   * 模块字段排序
   * @param {Object} fields
   * @returns {Object}
   */
  async setFieldsSort(fields) {
    return Promise.resolve(fields);
  }

  /**
   * 设置动态渲染组件
   * @param {Object} config 模块表单配置
   * @param {Object} controller 控制器
   * @param {Object} payload 传递的数据，不限制键名和值
   */
  async setDynamicComponent(config, controller, payload) {
    if (config && controller && payload) {
      const { raw_ref_form_model, raw_form_model, form_assign_data } = payload;
      const is_site_set_type_changed = JSON.stringify(raw_ref_form_model['campaign_config.site_form']?.site_set_type) !== JSON.stringify(raw_form_model['campaign_config.site_form']?.site_set_type);
      const is_site_sets_changed = JSON.stringify(raw_ref_form_model['campaign_config.site_form']?.site_sets) !== JSON.stringify(raw_form_model['campaign_config.site_form']?.site_sets);
      const is_delivery_platform_type_changed = JSON.stringify(raw_ref_form_model['campaign_config.delivery_form']?.delivery_platform_type) !== JSON.stringify(raw_form_model['campaign_config.delivery_form']?.delivery_platform_type);
      const is_media_type_changed = JSON.stringify(raw_ref_form_model['campaign_config.delivery_form']?.media_type) !== JSON.stringify(raw_form_model['campaign_config.delivery_form']?.media_type);

      if (is_delivery_platform_type_changed || is_media_type_changed || is_site_set_type_changed || is_site_sets_changed) {
        delete form_assign_data.creative_config;

        const {
          creative_config: {
            config: {
              content_form: {
                config: {
                  delivery_mode,
                  creative_template_id,
                },
              },
            },
          },
        } = config;

        const template_params = {
          filtering: {
            site_sets: raw_ref_form_model['campaign_config.site_form']?.site_sets,
            delivery_platform_type: raw_ref_form_model['campaign_config.delivery_form']?.delivery_platform_type,
          },
          vivo_params: {
            filtering: {
              delivery_mode: delivery_mode.value,
              media_type: raw_ref_form_model['campaign_config.delivery_form']?.media_type,
            },
          },
        };
        // 获取创意规格选项
        creative_template_id.options = await controller.getCreativeTemplateList(template_params);
        const is_has_data = !!creative_template_id.options.length;
        creative_template_id.hidden = !is_has_data;
        creative_template_id.value = is_has_data ? creative_template_id.options[0].value : null;
        creative_template_id.backup_value = creative_template_id.value;

        const params = {
          filtering: {
            site_sets: raw_ref_form_model['campaign_config.site_form']?.site_sets,
          },
          ...(creative_template_id.value && {
            vivo_params: {
              filtering: {
                creative_template_id: creative_template_id.value,
              },
            },
          }),
        };

        await this.renderDynamicComponent({ config, params, controller });
      }
    }
  }

  /**
   * 渲染创意动态组件
   * @param {Object} data 配置项
   * @param {Object} data.config 模块表单配置
   * @param {Object} data.params 查询参数
   * @param {Object} data.controller 控制器
   * @param {string[]} data.creative_config_keys 创意配置键
   */
  async renderDynamicComponent({ config, params, controller }) {
    const {
      campaign_config: {
        config: {
          delivery_form,
          site_form,
        },
      },
      creative_config: {
        config: {
          content_form,
          creative_components,
        },
      },
      material_config: {
        config: {
          material_form,
        },
      },
    } = config;

    const { delivery_platform_type, media_type } = delivery_form.config;
    const { site_sets } = site_form.config;
    const { delivery_mode, creative_template_id, delivery_position_list } = content_form.config;

    const is_shop = media_type.value === '0';
    delivery_position_list.hidden = is_shop;
    // 非商店才支持
    if (!is_shop) {
      delivery_position_list.options = await controller.getDeliveryPosition({
        vivo_params: {
          filtering: {
            delivery_platform_type: delivery_platform_type.value,
            media_type: media_type.value,
            site_set_id: site_sets.value[0],
            delivery_mode: delivery_mode.value,
            creative_template_id: creative_template_id.value,
          },
        },
      });
      delivery_position_list.value = delivery_position_list.options.map(({ value }) => value);
    } else {
      // 隐藏投放位置
      delivery_position_list.options = [];
      delivery_position_list.value = [];
    }

    const { names, list } = await controller.getDynamicComponent(params);
    // 重新初始化【创意组件】表单配置
    creative_components.config = clone(creative_components_config);
    const dynamic_component_keys = ['creative_ad_desc'];

    [creative_components].forEach(target => {
      Object.keys(target.config).forEach(key => {
        if (!names.includes(key) && dynamic_component_keys.includes(key)) {
          delete target.config[key];
        }
      });
      const ret = list.filter(item => target.config[item.name]);
      list.forEach((item) => Object.assign(item, { element_type: target.config[item.name]?.type, default_value: target.config[item.name]?.default_value }));
      target.config = deepMerge([target.config, generateDynamicFormModel(ret)]);
    });

    const {
      material,
    } = material_form.config;

    const mapTuple = [
      // 图片素材限制 - 仅存在image字段，如同时存在video字段，则表示该image为视频封面配置，需忽略
      [
        () => !names.includes('video') && names.includes('image'),
        () => {
          const image = list.find(item => item.name === 'image');
          const width = image?.restriction?.image_restriction?.width;
          const height = image?.restriction?.image_restriction?.height;
          const is_has_restriction = width && height;
          const is_image_list = image?.array_property?.max_number > 1;
          material.materialRestriction = is_has_restriction ? [{ width, height }] : [];
          material.material_type = is_image_list ? 'element_story' : 'image';
          material.value.videos = [];
          material.value.tab = 'image';
        },
      ],
      // 视频素材限制
      [
        () => names.includes('video'),
        () => {
          const video = list.find(item => item.name === 'video');
          const width = video?.restriction?.video_restriction?.min_width;
          const height = video?.restriction?.video_restriction?.min_height;
          const is_has_restriction = width && height;
          material.materialRestriction = is_has_restriction ? [{ width, height }] : [];
          material.material_type = 'video';
          material.value.images = [];
          material.value.tab = 'video';
        },
      ],
      // 不限制素材
      [
        () => !names.includes('video') && !names.includes('image'),
        () => {
          material.materialRestriction = [];
          material.material_type = null;
          material.value.tab = 'video';
        },
      ],
    ];
    mapTuple.forEach(([condition, handler]) => (condition() && handler()));
  }

  /**
   * 转换差异化广告预览参数
   * @param {Object} data 数据
   * @param {Object} data.form_assign_data 提交参数
   */
  transformDifferentiatedCampaignPreviewPayload({ form_assign_data }) {
    const {
      campaign_config: {
        delivery_form: {
          media_type,
        },
        schedule_form: {
          time_period_type,
          schedule_time,
          time_period,
        },
        budget_and_bid_form: {
          spent_type,
          converted_user_filter_days,
          fusion__optimize_goal,
          convert_goal_price,
          convert_goal_roi,
          deep_convert_type,
          deep_convert_goal_price,
          deep_convert_goal_roi,
        },
      },
    } = form_assign_data;

    return {
      // 投放时间类型
      time_period_type,
      // 投放时间 - 全天
      ...(time_period_type === 'TIME_PERIOD_ALL' && { time_period: new Array(TIME_PERIOD_LENGTH.HALF_HOUR).fill(1).join('') }),
      // 投放时间 - 指定时间
      ...(time_period_type === 'TIME_PERIOD_DAY_SPECIFIC' && { time_period: transformSelectedTimeToTimeSeries(schedule_time.start, schedule_time.end) }),
      // 投放时间 - 指定多个时间
      ...(time_period_type === 'TIME_PERIOD_HOUR_SPECIFIC' && { time_period: time_period.schedule_time_content }),
      // 计划类型
      ...(media_type && { media_type }),
      // 投放类型
      ...(spent_type && { spent_type }),
      // 过滤已转化用户天数
      ...(converted_user_filter_days && { converted_user_filter_days }),
      // 优化目标
      ...(fusion__optimize_goal && { convert_goal: fusion__optimize_goal }),
      // 优化目标出价
      ...(convert_goal_price && { convert_goal_price: calculator.times(convert_goal_price, 100) }),
      // 优化ROI系数出价
      ...(convert_goal_roi && { convert_goal_roi }),
      // 深度优化目标
      ...(deep_convert_type && { deep_convert_goal: deep_convert_type }),
      // 深度优化出价
      ...(deep_convert_goal_price && { deep_convert_goal_price: calculator.times(deep_convert_goal_price, 100) }),
      // 深度ROI系数出价
      ...(deep_convert_goal_roi && { deep_convert_goal_roi }),
    };
  }

  /**
   * 转换差异化创意预览参数
   * @param {Object} data 数据
   * @param {Object} data.form_assign_data 提交参数
   * @returns {Object}
   */
  transformDifferentiatedCreativePreviewPayload({ form_assign_data }) {
    const {
      creative_config: {
        content_form: {
          delivery_mode,
          creative_template_id,
          delivery_position_list,
        } = {},
        creative_components: {
          creative_ad_desc,
        },
      },
    } = form_assign_data;

    return {
      // 投放模式
      delivery_mode,
      // 创意规格ID
      ...(creative_template_id && { creative_template_id }),
      // 投放位置
      ...(delivery_position_list && { delivery_position_list }),
      // 创意文案
      ...(creative_ad_desc && { creative_ad_desc }),
    };
  }

  /**
   * 获取创建定向包差异化接口参数
   * @param {Object} target_data 定向数据
   * @returns {Object}
   */
  getDifferentiatedCreateTargetParams(target_data) {
    const {
      ages: {
        ages_selection,
        ages,
      },
      app_install_status,
      install_behavior: {
        install_behavior_selection,
        app_category,
        game_category,
        install_behavior_days,
      },
      start_behavior: {
        start_behavior_selection,
        app_category: start_behavior_app_category,
        game_category: start_behavior_game_category,
        start_behavior_type,
        start_behavior_days,
      },
      business_interest_list: {
        business_interest_list_selection,
        business_interest_list,
      },
      network_type,
      android_version_list: {
        android_version_list_selection,
        android_version_list,
      },
      device_price_list: {
        device_price_list_selection,
        device_price_list,
      },
      phone_series_list: {
        phone_series_list_selection,
        phone_series_list,
      },
      network_operator_list,
    } = target_data;

    const target_params = {
      [`${CHANNEL_INTERFACE_TYPE.VIVO}_params`]: {
        // 年龄
        ...(ages_selection === OPTIONS_TYPE.CUSTOM && { ages }),
        // APP安装
        app_install_status,
        // 安装行为
        ...(!install_behavior_selection.includes(OPTIONS_TYPE.UNLIMITED) && {
          install_behavior: {
            ...(install_behavior_selection.includes('app_category') && { app_category }),
            ...(install_behavior_selection.includes('game_category') && { game_category }),
            install_behavior_days,
          },
        }),
        // 启动行为
        ...(!start_behavior_selection.includes(OPTIONS_TYPE.UNLIMITED) && {
          start_behavior: {
            ...(start_behavior_selection.includes('app_category') && { app_category: start_behavior_app_category }),
            ...(start_behavior_selection.includes('game_category') && { game_category: start_behavior_game_category }),
            ...(start_behavior_days && { start_behavior_days }),
          },
          start_behavior_type,
        }),
        // 兴趣行为
        ...(business_interest_list_selection === OPTIONS_TYPE.CUSTOM && { business_interest_list }),
        // 网络环境
        network_type,
        // 安卓版本
        ...(android_version_list_selection === OPTIONS_TYPE.CUSTOM && { android_version_list }),
        // 购机价格
        ...(device_price_list_selection === OPTIONS_TYPE.CUSTOM && { device_price_list }),
        // 手机系列
        ...(phone_series_list_selection === OPTIONS_TYPE.CUSTOM && { phone_series_list }),
        // 运营商
        ...(!network_operator_list.includes(OPTIONS_TYPE.UNLIMITED) && { network_operator_list }),
      },
    };

    return target_params;
  }

  /**
   * 获取定向包差异化详情表单数据
   * @param {Object} target_params 定向详情数据
   * @returns {Object}
   */
  getDifferentiatedTargetDetailFormData(target_params) {
    const {
      [`${CHANNEL_INTERFACE_TYPE.VIVO}_params`]: {
        ages,
        app_install_status,
        install_behavior,
        start_behavior,
        start_behavior_type,
        business_interest_list,
        network_type,
        android_version_list,
        device_price_list,
        phone_series_list,
        network_operator_list,
      } = {},
    } = target_params;

    const form_data = {
      // 年龄
      ...(ages && {
        ages: {
          ages_selection: OPTIONS_TYPE.CUSTOM,
          ages,
        },
      }),
      // APP安装
      ...(app_install_status && { app_install_status }),
      // 安装行为
      ...(install_behavior && {
        install_behavior: {
          install_behavior_selection: [...(install_behavior.app_category ? ['app_category'] : []), ...(install_behavior.game_category ? ['game_category'] : [])],
          ...install_behavior,
        },
      }),
      // 启动行为
      ...(start_behavior && {
        start_behavior: {
          start_behavior_selection: [...(start_behavior.app_category ? ['app_category'] : []), ...(start_behavior.game_category ? ['game_category'] : [])],
          ...start_behavior,
          start_behavior_type,
        },
      }),
      // 兴趣行为
      ...(business_interest_list && {
        business_interest_list: {
          business_interest_list_selection: OPTIONS_TYPE.CUSTOM,
          business_interest_list,
        },
      }),
      // 网络环境
      ...(network_type && { network_type }),
      // 安卓版本
      ...(android_version_list && {
        android_version_list: {
          android_version_list_selection: OPTIONS_TYPE.CUSTOM,
          android_version_list,
        },
      }),
      // 购机价格
      ...(device_price_list && {
        device_price_list: {
          device_price_list_selection: OPTIONS_TYPE.CUSTOM,
          device_price_list,
        },
      }),
      // 手机系列
      ...(phone_series_list && {
        phone_series_list: {
          phone_series_list_selection: OPTIONS_TYPE.CUSTOM,
          phone_series_list,
        },
      }),
      // 运营商
      ...(network_operator_list && { network_operator_list }),
    };

    return form_data;
  }

  /**
   * 获取定向数据转预览数据关联表
   * @returns {Object}
   */
  getTargetPreviewAssociatedMap() {
    return {
      ages_selection: {
        associated_keys: ['ages'],
      },
      install_behavior_selection: {
        type: 'options',
        associated_keys: ['app_category', 'game_category'],
        associated_options_map: {
          app_category: 'app_category',
          game_category: 'game_category',
        },
      },
      start_behavior_selection: {
        type: 'options',
        associated_keys: ['app_category', 'game_category'],
        associated_options_map: {
          app_category: 'app_category',
          game_category: 'game_category',
        },
      },
      business_interest_list_selection: {
        associated_keys: ['business_interest_list'],
      },
      android_version_list_selection: {
        associated_keys: ['android_version_list'],
      },
      device_price_list_selection: {
        associated_keys: ['device_price_list'],
      },
      phone_series_list_selection: {
        associated_keys: ['phone_series_list'],
      },
    };
  }

  /**
   * 获取素材属性
   * @param {Object} material_config 素材表单配置
   * @returns {Object}
   */
  getMaterialProps(material_config) {
    const { materialRestriction, material_type } = material_config?.config?.material_form?.config?.material;
    return {
      materialRestriction,
      ...(material_type && { type: material_type }),
    };
  }

  /**
   * 设置源数据表单
   * @param {Object} source 源数据
   * @param {Object} target 目标数据
   * @returns {void}
   */
  setSourceFormFieldsData(source, target) {
    const {
      material_config: {
        config: {
          material_form: {
            config: {
              material,
            },
          },
        },
      },
    } = source;

    const {
      material_config: {
        config: {
          material_form: {
            config: {
              material: target_material,
            },
          },
        },
      },
    } = target;

    // 保持数据引用
    material.value.images.splice(0);
    material.value.images.push(...target_material.value.images);
    material.value.videos.splice(0);
    material.value.videos.push(...target_material.value.videos);
    material.value.tab = target_material.value.tab;

    Object.assign(material, {
      materialRestriction: target_material.materialRestriction,
      material_type: target_material.material_type,
    });
  }

  /**
   * 获取差异化模板配置表
   * @returns {Object}
   */
  getDifferentiatedTemplateMap() {
    return {
      campaign_config: {
        delivery_form: ['media_type'],
        budget_and_bid_form: ['spent_type'],
      },
      creative_config: {
        content_form: ['delivery_mode', 'creative_template_id', 'delivery_position_list'],
      },
    };
  }

  /**
   * 是否重新渲染动态创意
   * @param {Object} old_campaign_config 旧广告配置
   * @param {Object} new_campaign_config 新广告配置
   * @returns {Boolean}
   */
  isReRenderCreative(old_campaign_config, new_campaign_config) {
    const {
      delivery_form: {
        config: {
          delivery_platform_type: old_delivery_platform_type,
          media_type: old_media_type,
        },
      },
      site_form: {
        config: {
          site_set_type: old_site_set_type,
          site_sets: old_site_sets,
        },
      },
    } = old_campaign_config.config;

    const {
      delivery_form: {
        config: {
          delivery_platform_type: new_delivery_platform_type,
          media_type: new_media_type,
        },
      },
      site_form: {
        config: {
          site_set_type: new_site_set_type,
          site_sets: new_site_sets,
        },
      },
    } = new_campaign_config.config;

    const is_delivery_platform_type_changed = JSON.stringify(old_delivery_platform_type.value) !== JSON.stringify(new_delivery_platform_type.value);
    const is_media_type_changed = JSON.stringify(old_media_type.value) !== JSON.stringify(new_media_type.value);
    const is_site_set_type_changed = JSON.stringify(old_site_set_type.value) !== JSON.stringify(new_site_set_type.value);
    const is_site_sets_changed = JSON.stringify(old_site_sets.value) !== JSON.stringify(new_site_sets.value);

    return is_delivery_platform_type_changed || is_media_type_changed || is_site_set_type_changed || is_site_sets_changed;
  }

  /**
   * 是否显示预览按钮
   * @param {Object} form_assign_data 分配数据
   * @param {Object} form_fields 源数据
   * @param {Object} payload 配置参数
   * @returns {boolean}
   */
  isShowPreviewBtn(form_assign_data, form_fields) {
    const all_keys = [CAMPAIGN_MODULE_KEY, CREATIVE_MODULE_KEY, TARGETING_MODULE_KEY];
    const is_has_all_kays = all_keys.every(key => !!form_assign_data[key]);
    if (!is_has_all_kays) {
      return false;
    }

    const {
      campaign_config: {
        delivery_form: {
          media_type,
        },
      },
    } = form_assign_data;
    const is_shop = media_type === '0';

    if (is_shop) {
      return form_assign_data[TARGETING_MODULE_KEY].length > 0;
    } else {
      return super.isShowPreviewBtn(form_assign_data, form_fields);
    }
  }
}
